'use strict';

/**
 *
 * @name: ngDelay
 *
 */

function NgDelayDirective($timeout) {

  'ngInject';

  return {
    restrict: 'A',
    scope: true,
    compile: function(element, attributes) {

      var expression = attributes.ngChange;

      if (!expression) {
        return;
      }

      var ngModel = attributes.ngModel;

      if (ngModel) {

        attributes.ngModel = '$parent.' + ngModel;
      }

      attributes.ngChange = '$$delay.execute()';
      var instantNoDelay = attributes.instantNoDelay;

      return {
        post: function(scope, element, attributes) {

          scope.$$delay = {
            expression: expression,
            delay: scope.$eval(attributes.ngDelay),
            execute: function() {

              if (instantNoDelay) {

                scope.$parent[instantNoDelay]();
              }

              var state = scope.$$delay;
              state.then = Date.now();

              $timeout(function() {

                if (Date.now() - state.then >= state.delay) {

                  scope.$parent.$eval(expression);
                }
              }, state.delay);
            }
          };
        }
      };
    }
  };
}

export default NgDelayDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/ng-delay.directive.js